import { render, staticRenderFns } from "./LiveSelection.vue?vue&type=template&id=864f8810&scoped=true"
import script from "./LiveSelection.vue?vue&type=script&lang=js"
export * from "./LiveSelection.vue?vue&type=script&lang=js"
import style0 from "./LiveSelection.vue?vue&type=style&index=0&id=864f8810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864f8810",
  null
  
)

export default component.exports